import React from 'react';
import bg from '../assets/image6.png';

const Header = () => (
  <div className="raam-header">
    <div className="container top-nav">
      <div className="d-inline-block align-middle pr-2 pr-md-5"><img src={bg} alt="header" /></div>
      <div className="d-inline-block align-middle">THE WORLD&apos;S TOUGHEST BICYCLE RACE </div>
    </div>
  </div>
);

export default Header;
